module.exports = __webpack_public_path__ + "static/media/down_arrow.a174c58a.svg";